import { render } from "./EditaCaminhao.vue?vue&type=template&id=2e9b9a84&scoped=true&ts=true"
import script from "./EditaCaminhao.vue?vue&type=script&lang=ts"
export * from "./EditaCaminhao.vue?vue&type=script&lang=ts"

import "./EditaCaminhao.vue?vue&type=style&index=0&id=2e9b9a84&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9b9a84"]])

export default __exports__